<div class="container">
  <div class="offset-sm-1 col-sm-10 pt-5 webview text-center" [@flyInOut]="'in'">
    <h1 class="text-center font-weight-normal-calibre questxt">{{question}}</h1>
    <h1 class="text-center font-weight-normal-calibre pb-4 questxt" *ngIf="!isRenewal">{{question_q1}}</h1>
    <div class="col-sm-6 col-md-6 col-xl-6 m-auto text-left">
      <label class="custom-control custom-checkbox chkbox mb-2" for="renew3">
        <input type="checkbox" class="custom-control-input mgntp10" id="renew3" value="Yes"
          name="renewable" [(ngModel)]="hgRenewable.re_option3" (click)="getOption($event)" />
        <label class="custom-control-label font20" for="renew3">Yes</label>
      </label>
      <label class="custom-control custom-checkbox chkbox mb-2" for="renew2">
        <input type="checkbox" class="custom-control-input mgntp10" id="renew2" value="No" name="renewable"
          [(ngModel)]="hgRenewable.re_option2" (click)="getOption($event)" />
        <label class="custom-control-label font20" for="renew2">No</label>
      </label>
      <label class="custom-control custom-checkbox chkbox mb-2" for="renew1">
        <input type="checkbox" class="custom-control-input mgntp10" id="renew1" value="Only show renewable options"
          name="renewable" [(ngModel)]="hgRenewable.re_option1" (click)="getOption($event)" />
        <label class="custom-control-label font20" for="renew1">Only show renewable options</label>
      </label> 
    </div>
    <p class="m-0 mt-4 text-muted tapmsg">{{questionObj.chkboxtype}}</p>
    <button class="btn next mr-2 ml-2 disabledButton mt-2 font22 text-uppercase" [ngClass]="{'sectbtn': user_bot}"(click)="next();">Next</button>
    <!-- <p class="text-success mt-3">{{questionObj.tip}}</p> -->

    <div class="mt-5">
      <div class="m-auto col-sm-10 col-md-6 col-xl-6 blockbg boxclr text-center">
        <img src="assets/images/flash.png" class="mb-1" />
        <p class="text-center tiphead">DEFINITION</p>
        <p class="text-center tipmes">{{questionObj.tip}}</p>
        <!-- <p class="text-center font-weight-bold">DEFINITION<br>
        <a class="font-weight-normal">{{questionObj.tip}}</a></p> -->
      </div>
    </div>
  </div>
</div>
<div class="container mobileview mt-4 px-0" [attr.id]="questionObj._id">
  <div class="d-flex h-100 row col-sm-12 pr-0">
    <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
      <img style="width:100%;" src="assets/images/signimg.jpg" />
    </div>
    <div class="col-sm-9 col-9 px-0 my-auto">
      <div class="arrow_box" >
        <h1 class="questionMob text-left">{{question}}</h1>
      </div>
    </div>
  </div>
  <div class="row col-sm-12 m-auto">
    <label class="custom-control custom-checkbox chkbox mb-2" for="renew3_mob">
      <input type="checkbox" class="custom-control-input mgntp10" id="renew3_mob" value="Yes"
        name="renewable" [(ngModel)]="hgRenewable.re_option3" (click)="getOption($event)" />
      <label class="custom-control-label font20" for="renew3_mob">Yes</label>
    </label>
    <label class="custom-control custom-checkbox chkbox mb-2" for="renew2_mob">
      <input type="checkbox" class="custom-control-input mgntp10" id="renew2_mob" value="No" name="renewable"
        [(ngModel)]="hgRenewable.re_option2" (click)="getOption($event)" />
      <label class="custom-control-label font20" for="renew2_mob">No</label>
    </label>
    <label class="custom-control custom-checkbox chkbox mb-2" for="renew1_mob">
      <input type="checkbox" class="custom-control-input mgntp10" id="renew1_mob" value="Only show renewable options"
        name="renewable" [(ngModel)]="hgRenewable.re_option1" (click)="getOption($event)" />
      <label class="custom-control-label font20" for="renew1_mob">Only show renewable options</label>
    </label>
    <p class="m-auto mt-4 text-muted tapmsg">{{questionObj.chkboxtype}}</p>
    <div style="width:97% !important; text-align: right;">
      <div *ngIf="user_bot" class="ash_box text-right mb-2" >
        <h1 class="ansMob text-right">{{renewable}}</h1>
      </div>
    </div>
    <br />
    <div *ngIf="showTip">
      <div>
        <div class="m-auto col-sm-10 col-md-6 col-xl-4 blockbg boxclr">
          <img src="assets/images/flash.png" class="mb-1" style="margin-left: 48%" />
          <p class="text-center tiphead">DEFINITION</p>
          <p class="text-center tipmes">{{questionObj.tip}}</p>
          <!-- <p class="text-center font-weight-bold">DEFINITION<br>
            <a class="font-weight-normal">{{questionObj.tip}}</a></p> -->
        </div>
      </div>
    </div>
    
  </div>
</div>
<!-- <div class="btm-process webview">
  <div class="text-center" *ngIf="!messagetype">
    <span><img src="assets/images/active25.png"></span>
    <h4 class="clr333 processtxt">15% Completed</h4>
  </div>
  <div class="text-center" *ngIf="messagetype">
    <span><img src="assets/images/active18.png"></span>
    <h5 class="clr333 processtxt">95% Completed</h5>
  </div>
</div> -->